import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import RootRoute from "./routes/Root";
import { ErrorContextProvider } from "./context/ErrorContext";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { ThemeProvider } from "@mui/material";
import { theme } from "./utils/theme/theme";

const router = createBrowserRouter([RootRoute]);

if (process.env.NODE_ENV === 'production') {
  console.warn = () => { };
  console.log = () => { };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY_V3} container={{
  //   parameters: {
  //     badge: 'bottomleft', // optional, default undefined
  //   }
  // }}>
  //   <ChakraProvider>

  //   </ChakraProvider>
  // </GoogleReCaptchaProvider>
  <ErrorContextProvider>
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={theme}>
        <RouterProvider router={router} />
      </ThemeProvider>
    </I18nextProvider>
  </ErrorContextProvider>
);
